<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Manage Role Menu" subTitle="Forms" />

    <MenuRole />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import MenuRole from "@/components/Pages/Master/Role/MenuRole.vue";

export default defineComponent({
  name: "MenuRolePage",
  components: {
    PageTitle,
    MenuRole,
  },
});
</script>
